<template>
    <div>
        <el-dialog
            title="冻结订单"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="800px">
            <le-pagview ref="eventlist" @setData="setTableData" :pageParam="pageParam" v-if="pageParam">
                <el-table :data="tabledata" :height='tabledata.length?"60vh":""'>
                    <el-table-column label="订单号" prop="typeText">
                        <template slot-scope="{ row }">
                            <span class="font-point a-c-blue" @click="toDetails(row)">{{ row.orderSn?row.orderSn:'-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="订单时间" prop="content">
                        <template slot-scope="{ row }">
                            <span>{{ row.orderTime || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="订单金额" prop="orderId">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.orderPrice) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="冻结金额" prop="operatorUserPhone">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.lockAmount) }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </le-pagview>
            <div slot="footer">
                <el-button type="primary"  @click="dialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import util from '../../../../src/utils/util'
    export default {
        data() {
            return {
                dialogVisible: false,
                util: util,
                pageParam: null,
                tabledata: [],
            };
        },
        props:['userId','phone'],
        methods:{
            getTableData () {
                this.pageParam = {
                    url: this.$Config.apiUrl.userLockOrderInfo,
                    method: "post",
                    params: {
                        userId: this.userId,
                        phone: this.phone,
                    },
                    freshCtrl: 1,
                }
            },
            setTableData (datas) {
                this.tabledata = datas.map(item=>{
                    return {
                        ...item,
                    }
                })
            },
            toDetails (datas) {
                if(datas.orderType == 1) {
                    this.$router.push({
                        path:'/order/package-order-info',
                        query: {
                            id: datas?datas.orderSn:''
                        }
                    })
                }else if(datas.orderType == 2) {
                    this.$router.push({
                        path: '/order/order-detail',
                        query: {
                            orderId: datas.orderSn,
                        }
                    })
                }else if(datas.orderType == 4 || datas.orderType == 5) {
                    this.$router.push({
                        path:'/order/chargeCabinet-order-info',
                        query: {
                            orderId: datas.orderSn,
                            orderSn: datas.orderSn
                        }
                    })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-dialog__wrapper{
        display: flex;
        justify-content: center !important;
        align-items: center !important;
    }
    /deep/ .el-dialog__body{
        padding: 10px 20px !important;
    }
    /deep/ .el-dialog{
        margin: 0 auto !important;
    }
    /deep/ .is-disabled{
        color: #333333 !important;
    }
    .formContent{
        // max-height: 70vh;
        // overflow: auto;
    }
    
    .tips{
        font-size: 12px;
        color: #909399;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        line-height: 22px;
    }
</style>